module.exports = __webpack_public_path__ + "img/4-1-3-1-preview-freetour-c.ca9bed43.jpg";